import { literals } from "@/constants/literals";
import { formatDateDDMmmYYYY } from "@/lib/dates";
import type { OrderItem, TRequestType } from "@/types/types.d";

const ResultCard = ({
  item,
  onClick,
}: {
  item: OrderItem;
  onClick: (item: OrderItem) => void;
}) => {
  const handleOnCLick = () => {
    onClick(item);
  };

  return (
    <button
      data-testid="photo-card"
      onClick={handleOnCLick}
      type="button"
      className="flex flex-col gap-2 border rounded-sm p-4 "
    >
      <div className="flex gap-2 justify-between text-left">
        <BlockInfo
          label={literals.date}
          value={formatDateDDMmmYYYY(item.createdAt)}
        />
        <BlockInfo label={literals.step} value={item.step} />
      </div>
      <div className="w-full border-t" />
      <div className="flex flex-col gap-2">
        <BlockInfoHorizontal
          label={literals.visibleClient}
          value={item.visible ? "Sí" : "No"}
        />
        <BlockInfoHorizontal label={literals.workstation} value={item.area} />
        <BlockInfoHorizontal
          label={literals.partIn}
          value={item.orderIn || "-"}
        />
        <BlockInfoHorizontal
          label={literals.serialIn}
          value={item.serialIn || "-"}
        />
        <BlockInfoVertical
          label={literals.description}
          value={item.description || ""}
        />
        <RequetTypeInfo requestType={item.requestType} />
      </div>
    </button>
  );
};

export default ResultCard;

const BlockInfo = ({ label, value }: { label: string; value: string }) => {
  return (
    <div className="block">
      <p className="text-sm">{label}</p>
      <p className="font-ib-bold text-md">{value}</p>
    </div>
  );
};

const BlockInfoHorizontal = ({
  label,
  value,
}: {
  label: string;
  value: string;
}) => {
  return (
    <div className="flex gap-1 justify-between items-center">
      <p className="text-[#666666]">{label}:</p>
      <p className="text-black">{value}</p>
    </div>
  );
};

const BlockInfoVertical = ({
  label,
  value,
}: {
  label: string;
  value: string;
}) => {
  return (
    <div className="block gap-1 text-left">
      <p className="text-[#666666]">{label}:</p>
      <p className="text-black">{value}</p>
    </div>
  );
};

const RequetTypeInfo = ({
  requestType,
}: {
  requestType: TRequestType | null | undefined;
}) => {
  if (!requestType) return null;

  return (
    <div className="flex gap-1 justify-between items-center">
      <p className="text-[#666666]">Solicitud activa:</p>
      {requestType === "EDIT" && <p className="text-[#C7A400]">Edición</p>}
      {requestType === "DELETE" && <p className="text-[#A8191A]">Borrado</p>}
    </div>
  );
};
